<template>
  <section id="dashboard">
    <div class="flex flex-col justify-center align-center px-10">
      <div class="flex items-center justify-between text-left w-full">
        <h1 class="big-title mb-0">Liste des projets</h1>

        <router-link
          :to="{ name: 'Projects Archive' }"
          title="Voir mes projets archivés"
        >
          <div class="nav-link">
            <Button
              label="Projets archivés"
              icon="mdi-archive"
              :icon-size="24"
            />
          </div>
        </router-link>
      </div>

      <!-- ANCHOR Filtres -->
      <div class="filters flex mt-2 mb-5">

          <div class="p-inputgroup mr-3">
              <InputText v-model="searchFilter" placeholder="Rechercher par titre" />
              <Button
                icon="mdi-magnify"
                :icon-size="25"
              />
          </div>

          <div class="p-inputgroup">
              <Dropdown v-model="selectedFilter" :options="filters" optionLabel="name" placeholder="Filtrer par type">
              <template #value="filter">
                <div v-if="filter.value">
                    <div>{{filter.value.name}}</div>
                </div>
                <span v-else>
                    {{filter.placeholder}}
                </span>
              </template>
              </Dropdown>
          </div>

          <Button
            @click="resetFilters"
            class="ml-2"
            v-if="searchFilter || selectedFilter"
            icon="mdi-close"
            :icon-size="20"
          />
      </div>

      <!-- ANCHOR Invitations -->
      <InvitationsList @reloadProject="reloadProject" />

      <div class="flex flex-wrap items-center">

          <!-- ANCHOR Boucle sur les projets -->
          <skeleton-loader-vue v-if="!isLoaded"
            class="mt-5 mr-5"
            type="rect"
            :width="300"
            :height="170"
            animation="wave"
            rounded
          />

          <div class="project-card mt-5 mr-5 relative" v-for="project in projects_filtered" :class="[`bg-${project.color}`]"
              :key="project.id" :v-if="projects_filtered && isLoaded">
              <router-link :to="getProjectLink(project)" :title="[`Accéder au projet ${project.title}`]">
                <div class="project-card-content">
                  <div class="relative text-white px-6 py-6">
                    <h3 class="mb-1 mt-0">{{project.title}}</h3>
                    <small v-if="project.creator_user_id !== userId" class="mb-1 mt-0 uppercase">créé par {{project.creator.username}}</small>
                    <p class="mb-4 max-w-xs project-description">{{project.description}}</p>
                    <div class="flex items-center justify-between">
                      <span class="block uppercase">{{project.type}}</span>
                      <span class="block bg-white rounded-full px-3 font-semibold py-2 leading-none flex items-center" :class="[`text-${project.color}`]">{{project.date}}</span>
                    </div>
                  </div>
                </div>
              </router-link>
          </div>



        <!-- ANCHOR Fin de la boucle -->
        <router-link v-if="isLoaded" :to="{ name: 'Create Project' }" title="Créer un nouveau projet">
          <div class="project-card card-outline mt-3 mr-5 relative">
              <v-mdi size="30" name="mdi-plus" class="mr-2"></v-mdi>
              <h3>Nouveau projet</h3>
          </div>
        </router-link>

      </div>
    </div>
  </section>
</template>

<script>

import axios from 'axios';
import InvitationsList from '../../components/Invitation/InvitationList.vue';

export default {
  components: { InvitationsList },
  name: 'AllSnippets',
  data: () => ({
    searchFilter: null,
		selectedFilter: null,
    isLoaded: false,
    filters: [
			{name: 'Mode enseignement', value: 'Enseignement'},
			{name: 'Mode équipe', value: 'Équipe'},
			{name: 'Mode examen', value: 'Examen'},
		],
    projects: [],
  }),
  mounted: function(){
    //   Récupération des projets
    this.userId = this.$store.state.auth.id;

    axios
    .get(`${axios.defaults.baseURL}me/projects`, { 'headers': {Authorization: `Bearer ${this.$store.state.auth.token}`}})
    .then(response => {
      if(response.data){
        this.projects = response.data;
        this.isLoaded = true;
      }
    })
    .catch(error => {
      if(error) console.log(error);
    });

    this.$store.dispatch('projects/fetchRecents')
  },
  methods: {
    getProjectLink(project) {
      if (project.groups.length === 1) {
        const uniqueGroupId = project.groups[0].id
        return `/projects/${project.id}/groups/${uniqueGroupId}`
      } else {
        const modelGroupId = project.groups.find(group => group.is_model).id
        return `/projects/${project.id}/groups/${modelGroupId}`
      }
    },
    resetFilters() {
      this.searchFilter = null;
      this.selectedFilter = null;
    },
    reloadProject(mustReload){
      if(mustReload){

        // Rechargement des projets
        axios
        .get(`${axios.defaults.baseURL}me/projects`, { 'headers': {Authorization: `Bearer ${this.$store.state.auth.token}`}})
        .then(response => {
          if(response.data){
            this.projects = response.data;
          }
        })
        .catch(error => {
          if(error) console.log(error);
        });
      }
    }
  },
  computed: {
    projects_filtered: function () {
      let filteredList = this.projects;

      if(this.selectedFilter)
        filteredList = filteredList.filter(i => i.type === this.selectedFilter.value);

      if (this.searchFilter)
        filteredList = filteredList.filter(i => i.title.toLowerCase().includes(this.searchFilter.toLowerCase()));

      return filteredList;
    },
  }
};
</script>
